import { z } from "zod";
import type { DatabaseRecord } from "./schema";

export interface AddWaitingListEntryRequest {
  name: string;
  email: string;
  organizationName?: string;
  jobTitle?: string;
  roleDescription?: string;
  campaignId: "nadd2026" | "nnoha2026" | "dental";
  source: string;
}

export interface WaitingListEntry extends DatabaseRecord, AddWaitingListEntryRequest {
  id?: string;
}

export interface AddWaitingListEntryResponse {
  success: boolean;
  id: string;
}

export const zWaitingListEntry = z
  .object({
    name: z.string().trim().max(200).default(""),
    email: z
      .string()
      .trim()
      .max(254)
      .pipe(z.union([z.literal(""), z.string().email()]))
      .default("")
      .transform((email) => email.toLowerCase()),
    organizationName: z.string().trim().max(200).optional().default(""),
    jobTitle: z.string().trim().max(200).optional(),
    roleDescription: z.string().trim().max(5000).default(""),
    campaignId: z.enum(["nadd2026", "nnoha2026", "dental"]),
    source: z
      .string()
      .url()
      .max(2048)
      .refine((source) => /^https?:\/\//.test(source), "A web source URL is required"),
  })
  .superRefine((entry, context) => {
    if (entry.campaignId !== "dental") return;
    if (!entry.name) {
      context.addIssue({ code: z.ZodIssueCode.custom, path: ["name"], message: "A name is required" });
    }
    if (!entry.email) {
      context.addIssue({ code: z.ZodIssueCode.custom, path: ["email"], message: "An email address is required" });
    }
  });
